import getAllTableViewsContainingItemsForFolder from './getAllTableViewsContainingItemsForFolder';
import getAllTableViewsContainingItemsForGroup from './getAllTableViewsContainingItemsForGroup';
import { MailboxType } from 'owa-client-ids';
/**
 * Get all the table views that may contain items given the information passed in
 * @param mailboxInfo the mailbox info of the item
 * @param parentFolderId the parent folder id for the item
 * @param shouldIncludeSearchTable - whether to include the search table in the table list being returned
 */
export default function getAllTableViewsContainingItems(mailboxInfo, parentFolderId, shouldIncludeSearchTable) {
    var tableViews = [];
    if (mailboxInfo && mailboxInfo.type == MailboxType.GroupMailbox) {
        tableViews = getAllTableViewsContainingItemsForGroup(mailboxInfo.mailboxId, shouldIncludeSearchTable);
    }
    else {
        tableViews = getAllTableViewsContainingItemsForFolder(parentFolderId, shouldIncludeSearchTable);
    }
    return tableViews;
}
//# sourceMappingURL=getAllTableViewsContainingItems.js.map